const RESPONSES = {
  PENDING: 'Awaiting response',
  REJECTED: 'Rejected',
  ACCEPTED: 'Accepted',
  WITH_REVISIONS: 'Accepted with revisions',
};

export default RESPONSES;
